import { render, staticRenderFns } from "./modal-edit-user-examens.html?vue&type=template&id=bd70b120&scoped=true&external"
import script from "./modal-edit-user-examens.js?vue&type=script&lang=js&external"
export * from "./modal-edit-user-examens.js?vue&type=script&lang=js&external"
import style0 from "./modal-edit-user-examens.scss?vue&type=style&index=0&id=bd70b120&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd70b120",
  null
  
)

export default component.exports